import { Buffer } from "buffer";

export function encryptStringToBase64String(stringToFormat: string) {
  return Buffer.from(stringToFormat, "utf-8").toString("base64");
}
